import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=9637d0e6&scoped=true"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=9637d0e6&prod&scoped=true&lang=less"
import style1 from "./Delivery.vue?vue&type=style&index=1&id=9637d0e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9637d0e6",
  null
  
)

export default component.exports